import Vue from 'vue';
import array from 'lodash/array';
import SelectList from '../../general/elements/selectlist';
import ResourceStock from './resourcestock';
import PieceCollectionResourceStock from './piececollectionresourcestock';

export default Vue.component('stockmanager', {
    components:{
        'selectlist': SelectList,
        'resourcestock': ResourceStock,
        'piececollectionresourcestock': PieceCollectionResourceStock
    },
    template:`
    <div class="block block-themed block-rounded">
        <div class="block-header bg-warning" v-if="permissions.canEdit">
            <h3 class="block-title">{{sentences.title}}</h3>
        </div>
        <div class="block-content alert-warning" v-if="permissions.canEdit">
            <div class="table-responsive">
                <h3 class="h4">{{sentences.collectionResourcesTitle}}</h3>
                <table class="table table-borderless table-vcenter">
                    <thead>
                        <tr>
                            <th>{{sentences.combination}}</th>
                            <th style="width: 60px;" class="text-center">{{sentences.actionsColumnTitle}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="waste in collectionResourcesWastes.selected">
                            <td>{{createWasteSelectOptionText(waste)}}</td>
                            <td class="text-center">
                                <button class="btn btn-xs btn-warning" type="button" v-on:click="removeCollectionWasteCombination(waste.id)">
                                    <i class="fa fa-times"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-show="collectionResourcesWastes.unselected.length > 0">
                        <tr>
                            <td>
                                <selectlist :settings="collectionResourcesWastesListSettings" @input="selectedCollectionWasteCombination" />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="table-responsive">
                <h3 class="h4">{{sentences.pieceCollectionTitle}}</h3>
                <table class="table table-borderless table-vcenter">
                    <thead>
                        <tr>
                            <th>{{sentences.pieceCollectionTitle}}</th>
                            <th style="width: 60px;" class="text-center">{{sentences.actionsColumnTitle}}</th>
                        </tr>
                    </thead>
                    <tbody v-show="pieceCollectionResourcesWastes.selected.length > 0">
                        <tr v-for="waste in pieceCollectionResourcesWastes.selected">
                            <td>{{createWasteSelectOptionText(waste)}}</td>
                            <td class="text-center">
                                <button class="btn btn-xs btn-warning" type="button" v-on:click="removePieceCollectionWasteCombination(waste.id)">
                                    <i class="fa fa-times"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-show="pieceCollectionResourcesWastes.unselected.length > 0">
                        <tr class="col-12">
                            <td>
                                <selectlist :settings="pieceCollectionResourcesWastesListSettings" @input="selectedPieceCollectionWasteCombination" />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="block-content">
            <div class="table-responsive" v-show="collectionResourcesStock.length > 0">
                <h3 class="h4">{{sentences.collectionResources}}</h3>
                <h4 class="h5">{{sentences.overviewCollectionResources}}</h4>
                <table class="table table-vcenter">
                    <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">
                                <i class="si si-camera"></i>
                            </th>
                            <th style="width: 80px;">{{sentences.abbr}}</th>
                            <th>{{sentences.fullName}}</th>
                            <th style="width: 120px">{{sentences.fractions}}</th>
                            <th style="width: 100px;" class="text-center">{{sentences.stock}}<small style="display: block; font-size: 10px;">{{sentences.exceptOpenOrders}}</small></th>
                            <th style="width: 100px;" class="text-center">{{sentences.stock}}<small style="display: block; font-size: 10px;">{{sentences.includeOpenOrders}}</small></th>
                            <th style="width: 120px;">{{sentences.outsourcedTo}}</th>
                            <th style="width: 60px;" class="text-center" v-if="permissions.canEdit">{{sentences.actionsColumnTitle}}</th>
                        </tr>
                    </thead>
                    <resourcestock v-for="resource in collectionResourcesStock" :key="resource.code" v-bind="{resource: resource, resourceImage: collectionResourcesWastes.selected.find(w => w.collectionResource === resource.code).resourceImage, permissions: permissions}" />
                </table>
            </div>
            <div class="table-responsive" v-show="pieceCollectionResourcesStock.length > 0">
                <h3 class="h4">{{sentences.pieceCollection}}</h3>
                <h4 class="h5">{{sentences.overviewRotation}}</h4>
                <table class="table table-vcenter">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th style="width:50px;" class="text-center">
                                <i class="si si-camera"></i>
                            </th>
                            <th style="width:80px;">{{sentences.abbr}}</th>
                            <th>{{sentences.fullName}}</th>
                            <th style="width:320px;">{{sentences.fractions}}</th>
                            <th style="width:120px;">{{sentences.outsourcedTo}}</th>
                            <th style="width:60px;" class="text-center" v-if="permissions.canEdit">{{sentences.actionsColumnTitle}}</th>
                        </tr>
                    </thead>
                    <piececollectionresourcestock v-for="resource in pieceCollectionResourcesStock" :key="resource.code" v-bind="{resource: resource, resourceImage: pieceCollectionResourcesWastes.selected.find(w => w.collectionResource === resource.code).resourceImage, permissions: permissions}" />
                </table>
            </div>
        </div>
    </div>        
    `,
    data: function(){
        return {
        }
    },
    props:{
        collectionResourcesWastes: Object,
        pieceCollectionResourcesWastes: Object,
        collectionResourcesStock: Array,
        pieceCollectionResourcesStock: Array,
        permissions: Object,
        sentences: Object
    },
    computed: {
        collectionResourcesWastesListSettings(){
            return this.createWasteSelectOptions(this.collectionResourcesWastes.unselected);
        },
        pieceCollectionResourcesWastesListSettings(){
            return this.createWasteSelectOptions(this.pieceCollectionResourcesWastes.unselected);
        }
    },
    methods:{
        getResourceStock(collectionResource){
            let index = array.findIndex(this.collectionResourcesStock, ['code', collectionResource]);
            let resourceStock = this.collectionResourcesStock[index];

            return resourceStock;
        },
        getPieceCollectionResourceStock(collectionResource){
            let index = array.findIndex(this.pieceCollectionResourcesStock, ['code', collectionResource]);
            let resourceStock = this.pieceCollectionResourcesStock[index];

            return resourceStock;
        },
        createWasteSelectOption(waste){
            return {
                id: waste.id,
                text: this.createWasteSelectOptionText(waste),
            }
        },
        createWasteSelectOptionText(waste){
            return [waste.collectionResource, waste.fraction, waste.subFraction, waste.productName].filter(x => x).join(' - ');
        },
        createWasteSelectOptions(wastes){
            wastes.sort(this.wasteCollectionSort);

            let defaultOption = this.createSelectDefaultOption();
            let wasteOptions = wastes.map(this.createWasteSelectOption);
            
            wasteOptions.splice(0, 0, defaultOption);

            return { items: wasteOptions };
        },

        createResourceStock(waste){
            return {
                code: waste.collectionResource,
                name: waste.name,
                fractions: [{ code: waste.fraction, resourceImage: waste.resourceImage }],
                amount: 0,
                forecastAmount: 0,
                outsourcer: { id: null, code: null, name: null }
            };
        },
        createSelectDefaultOption(){
            return { text: this.sentences.pleaseSelectWaste };
        },
        /**
         *  Move selected waste combination from unselected to selected list 
         * */
        selectedCollectionWasteCombination(wasteCombinationId){
            let unselectedWastes = this.collectionResourcesWastes.unselected;
            let selectedWastes = this.collectionResourcesWastes.selected;
            let index = array.findIndex(unselectedWastes, ['id', wasteCombinationId]);
            let waste = unselectedWastes[index];
            
            unselectedWastes.splice(index, 1);
            selectedWastes.push(waste);
            selectedWastes.sort(this.wasteCollectionSort);

            // get resource stock, and add fractions to array
            let resourceStock = this.getResourceStock(waste.collectionResource);

            if(resourceStock !== undefined){
                resourceStock.fractions.push({code: waste.fraction, resourceImage: waste.resourceImage });
                resourceStock.fractions.sort(this.resourceStockSort);
            } else {
                this.collectionResourcesStock.push(this.createResourceStock(waste));
                this.collectionResourcesStock.sort(this.resourceStockSort);
            }
        },
        /**
         * Move selected waste combination from selected to unselected list.
         * Remove fraction from resource stock item, if last one was removed, remove the entry completly.
         */
        removeCollectionWasteCombination(wasteCombinationId){
            let unselectedWastes = this.collectionResourcesWastes.unselected;
            let selectedWastes = this.collectionResourcesWastes.selected;
            let index = array.findIndex(selectedWastes, ['id', wasteCombinationId]);
            let waste = selectedWastes[index];
            
            selectedWastes.splice(index, 1);
            unselectedWastes.push(waste);

            // get resource stock, and add fractions to array
            let resourceStock = this.getResourceStock(waste.collectionResource);
            
            if(resourceStock !== undefined){
                let fractionIndex = array.findIndex(resourceStock.fractions, ['code', waste.fraction]);
                
                resourceStock.fractions.splice(fractionIndex, 1);

                if(resourceStock.fractions.length === 0){
                    let index = array.findIndex(this.collectionResourcesStock, ['code', waste.collectionResource]);
                    this.collectionResourcesStock.splice(index, 1);
                }
            }
        },
        /** 
         * Move selected waste combination from unselected to selected list 
         * */
        selectedPieceCollectionWasteCombination(wasteCombinationId){
            let unselectedWastes = this.pieceCollectionResourcesWastes.unselected;
            let selectedWastes = this.pieceCollectionResourcesWastes.selected;
            let index = array.findIndex(unselectedWastes, ['id', wasteCombinationId]);
            let waste = unselectedWastes[index];

            unselectedWastes.splice(index, 1);
            selectedWastes.push(waste);
            selectedWastes.sort(this.wasteCollectionSort);

            // get resource stock, and add fractions to array
            let resourceStock = this.getPieceCollectionResourceStock(waste.collectionResource);

            if(resourceStock !== undefined){
                resourceStock.fractions.push({code: waste.fraction, resourceImage: waste.resourceImage });
                resourceStock.fractions.sort(this.resourceStockSort);
            } else {
                this.pieceCollectionResourcesStock.push(this.createResourceStock(waste));
                this.pieceCollectionResourcesStock.sort(this.resourceStockSort);
            }
        },
        removePieceCollectionWasteCombination(wasteCombinationId){
            let unselectedWastes = this.pieceCollectionResourcesWastes.unselected;
            let selectedWastes = this.pieceCollectionResourcesWastes.selected;
            let index = array.findIndex(selectedWastes, ['id', wasteCombinationId]);
            let waste = selectedWastes[index];
            
            selectedWastes.splice(index, 1);
            unselectedWastes.push(waste);

            // get resource stock, and add fractions to array
            let resourceStock = this.getPieceCollectionResourceStock(waste.collectionResource);
            
            if(resourceStock !== undefined){
                let fractionIndex = array.findIndex(resourceStock.fractions, ['code', waste.fraction]);
                
                resourceStock.fractions.splice(fractionIndex, 1);

                if(resourceStock.fractions.length === 0){
                    let index = array.findIndex(this.pieceCollectionResourcesStock, ['code', waste.collectionResource]);
                    this.pieceCollectionResourcesStock.splice(index, 1);
                }
            }
        },
        resourceStockSort(resourceA, resourceB){
          return resourceA.code.localeCompare(resourceB.code);  
        },
        wasteCollectionSort(wasteA, wasteB){
            if(wasteA.collectionResource === wasteB.collectionResource){
                if(wasteA.fraction === wasteB.fraction){
                    if(wasteA.subFraction === wasteB.subFraction){
                        return wasteA.product.localeCompare(wasteB.product);
                    }
                    return wasteA.subFraction.localeCompare(wasteB.subFraction);
                }
                return wasteA.fraction.localeCompare(wasteB.fraction);
            }
            return wasteA.collectionResource.localeCompare(wasteB.collectionResource);
        }
    }
});